import { render, staticRenderFns } from "./ProfileMessagingCerts.vue?vue&type=template&id=d1bd829c&"
import script from "./ProfileMessagingCerts.vue?vue&type=script&lang=js&"
export * from "./ProfileMessagingCerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports